<CardBase {element}>
  <div class="signup-prompt" style={cssVars}>
    Enter your email so you don't miss another drop.
  </div>
  <div class="signup-input" style={cssVars}>
    <div class="signup-input-textbox">
      <List noHairlines>
        <ListInput
          type="text"
          placeholder="Enter Email"
          clearButton
          bind:value={textContent}
          onInput={(e) => textContent = e.target.value}
          onOnkeypress={(e) => console.log(e)}
        />
      </List>
    </div>
    <div class="signup-input-button">
      <Link iconF7="arrowshape_turn_up_right_fill" on:click={sendMessage}></Link>
    </div>
  </div>
</CardBase>

<style>*, *:before, *:after {
  box-sizing:border-box;
}

.signup-prompt {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 2rem !important;
  color: var(--email-signup-prompt-text-color);
}

.signup-input {
  width: 100%;
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  --f7-list-bg-color: var(--email-signup-input-background-color);
  --f7-input-bg-color: var(--email-signup-input-background-color);
  --f7-input-text-color: var(--email-signup-input-text-color);
  --f7-input-clear-button-color: var(--email-signup-input-clear-button-color);
  --f7-input-placeholder-color: var(--email-signup-input-placeholder-text-color);
}

.signup-input-textbox {
  flex: 1 0 75%;
  width: 75%;
  border: 1px solid var(--email-signup-input-border-color);
}

.signup-input-button {
  flex: 0 0;
  padding: 0px 0px 0px 10px;
  --f7-theme-color: var(--email-signup-arrow-tint-color);
}</style>

<script lang="ts">var _a, _b, _c, _d, _e, _f, _g;
import { YinzCamCardsServiceElement } from "yinzcam-cards";
import { List, ListInput, Link } from 'framework7-svelte';
import CardBase from "../../../common/CardBase.svelte";
import { getToken } from "inversify-token";
import ROOT from "../../../../../inversify.config";
import { YinzCamDropsServerToken } from "yinzcam-drops";
import { findSourceStore } from "../../../utilities";
import { Readable } from "svelte/store";
import { CardsDataSourceRegistration } from "../../../common/CardsDataSourceRegistration";
export let element;
export let sources;
export let sourceStore1;
$: promptTextColor = ((_a = element === null || element === void 0 ? void 0 : element.data) === null || _a === void 0 ? void 0 : _a.promptTextColor) || '#fff';
$: arrowTintColor = ((_b = element === null || element === void 0 ? void 0 : element.data) === null || _b === void 0 ? void 0 : _b.arrowTintColor) || '#fff';
$: inputTextColor = ((_c = element === null || element === void 0 ? void 0 : element.data) === null || _c === void 0 ? void 0 : _c.inputTextColor) || '#333';
$: inputBackgroundColor = ((_d = element === null || element === void 0 ? void 0 : element.data) === null || _d === void 0 ? void 0 : _d.inputBackgroundColor) || '#fff';
$: inputClearButtonColor = ((_e = element === null || element === void 0 ? void 0 : element.data) === null || _e === void 0 ? void 0 : _e.inputClearButtonColor) || '#666';
$: inputPlaceholderTextColor = ((_f = element === null || element === void 0 ? void 0 : element.data) === null || _f === void 0 ? void 0 : _f.inputPlaceholderTextColor) || 'rgba(192, 192, 192)';
$: inputBorderColor = ((_g = element === null || element === void 0 ? void 0 : element.data) === null || _g === void 0 ? void 0 : _g.inputPlaceholderTextColor) || '#D8D8D8';
$: cssVars = `
    --email-signup-prompt-text-color: ${promptTextColor};
    --email-signup-arrow-tint-color: ${arrowTintColor};
    --email-signup-input-text-color: ${inputTextColor};
    --email-signup-input-background-color: ${inputBackgroundColor};
    --email-signup-input-clear-button-color: ${inputClearButtonColor};
    --email-signup-input-placeholder-text-color: ${inputPlaceholderTextColor};
    --email-signup-input-border-color: ${inputBorderColor};
  `;
$: {
    sourceStore1 = findSourceStore($sources, 'YinzCamDropsServerCurrentDrop');
}
;
$: data = (sourceStore1 && $sourceStore1) ? $sourceStore1 : null;
$: active = (data === null || data === void 0 ? void 0 : data.Active) || false;
$: dropUuid = data === null || data === void 0 ? void 0 : data.Id;
const dropsServer = getToken(ROOT, YinzCamDropsServerToken);
let textContent = '';
function sendMessage() {
    if (!textContent || !active || !dropUuid) {
        return;
    }
    dropsServer.postDropSignup(dropUuid, textContent, null).then(() => console.log('drop signup posted!'));
    textContent = '';
}
</script>